import {ChevronIcon, Radio} from '@yandex-delivery/blocks'
import {useFormContext, useFormState} from '@yandex-delivery/form'
import React from 'react'

import {ExtraItemSlot} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import type {Props} from './types'

export function ReturnPointRequirement(props: Props) {
  const {children, onClick} = props
  const {watch, getFieldState} = useFormContext()
  const formState = useFormState()
  const returnPoint = watch('returnPoint')
  const {error} = getFieldState('returnPoint', formState)

  return (
    <React.Fragment>
      <ExtraItemSlot
        description={i18n('cargo.create.return-point.requirement-title', 'Указать адрес для возврата посылки')}
        onClick={onClick}
        title={i18n('cargo.create.return-point.requirement-title', 'Указать адрес для возврата посылки')}
      >
        {returnPoint ? <Radio error={error?.message} checked /> : <ChevronIcon data-e2e="return-address" />}
      </ExtraItemSlot>
      {children}
    </React.Fragment>
  )
}
